export const API = "https://kalanyoro-api.eu-4.evennode.com"


// Helper function to fetch with slow loading detection
let activeRequests = 0;
let slowLoadingTimeout = null;

const startRequest = () => {
    activeRequests++;
    if (activeRequests === 1) {
        slowLoadingTimeout = setTimeout(() => {
            window.dispatchEvent(new Event('api:slow_loading_start'));
        }, 1500); // 1.5 seconds threshold
    }
};

const endRequest = () => {
    activeRequests--;
    if (activeRequests <= 0) {
        activeRequests = 0;
        clearTimeout(slowLoadingTimeout);
        window.dispatchEvent(new Event('api:slow_loading_end'));
    }
};

async function customFetch(url, options) {
    startRequest();
    try {
        const response = await fetch(url, options);
        return response;
    } finally {
        endRequest();
    }
}

/**
 * Résout l'URL d'une image quel que soit son format de stockage.
 * - URL Supabase complète → retournée telle quelle (accès direct CDN)
 * - Ancienne référence GridFS (UUID ou ObjectId) → proxy via /image/
 * @param {string} ref - logo / profil field value from the DB
 * @returns {string} URL prête pour un attribut src
 */
export function getImageUrl(ref) {
    if (!ref) return "";
    if (typeof ref === "string" && ref.startsWith("http")) return ref;
    return `${API}/image/${ref}`;
}

/**
 * Checks an HTTP response for a 403 status and emits a global event to trigger logout.
 * Only fires when an authorized request (Bearer token) fails, not for unauthenticated calls.
 * @param {Response} response
 * @param {string} [tok] - The token that was sent with the request
 * @returns {Response} the same response (for chaining)
 */
function checkStatus(response, tok) {
    // Only trigger logout if we actually sent a token.
    // If tok is empty the user is already logged out – no need to fire the event again.
    if (tok && (response.status === 401 || response.status === 403 || response.status === 404)) {
        window.dispatchEvent(new Event("auth:forbidden"));
    }
    return response;
}

/**
 * Sends a POST request to the specified endpoint
 * 
 * @async
 * @param {string} link - The API endpoint path to send the request to
 * @param {Object|FormData} data - The data to send in the request body
 * @param {boolean} [stringify=true] - Whether to stringify the data (true for JSON, false for FormData)
 * @param {string} [tok=""] - Bearer token for authorization
 * @returns {Promise<Object>} The parsed JSON response from the API
 * 
 * @throws {Error} If the network request fails
 * 
 * @example
 * // Send JSON data
 * await Send('/users', { name: 'John' }, true, 'auth-token');
 * 
 * // Send FormData
 * const formData = new FormData();
 * await Send('/upload', formData, false, 'auth-token');
 */
export async function Send(link, data, stringify=true, tok=""){
    let head={
        //'Content-Type': 'multipart/form-data',
        authorization:"Bearer "+tok,
    }
    if(stringify){
        head={
            'Content-Type' : 'application/json',
            "authorization"  : "Bearer "+tok,
        }
    }
    const options = {
        method: 'post',
        headers: head,
        body: stringify ? JSON.stringify(data) : data
    };
    const response = await customFetch(API+link, options);
    return checkStatus(response, tok).json();
}

/**
 * Sends a GET request to the specified link with optional authorization token.
 *
 * @param {string} link - The endpoint to send the GET request to.
 * @param {string} [tok=""] - The optional authorization token to include in the request headers.
 * @returns {Promise<Object>} - A promise that resolves to the JSON response from the server.
 */
export async function Get(link, tok=""){
    const options = {
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            authorization:"Bearer "+tok,
        },
        cache: 'no-store' // Prevent browser from caching the response
    };
    const response = await customFetch(API+link, options);
    //if(response.statusText=== "Unauthorized") window.location.reload()
    return checkStatus(response, tok).json();
}

/**
 * Updates a resource at the specified link with the provided data.
 *
 * @param {string} link - The endpoint to which the request is sent.
 * @param {Object} data - The data to be sent in the request body.
 * @param {string} [tok=""] - The authorization token to be included in the request headers.
 * @param {boolean} [stringify=true] - Whether to stringify the data before sending it.
 * @returns {Promise<Object>} - A promise that resolves to the response data in JSON format.
 */
export async function Update(link, data, tok="", stringify=true){
    let head={
        //'Content-Type': 'application/json',
        authorization:"Bearer "+tok,
    }
    if(stringify){
        head={
            'Content-Type': 'application/json',
            authorization: "Bearer "+tok,
            'Accept': 'application/json',
        }
    }
    const options = {
        method: 'put',
        headers: head,
        body: stringify ? JSON.stringify(data) : data
    }; 
    const response = await customFetch(API+link, options);
    return checkStatus(response, tok).json();
}

/**
 * Sends a DELETE request to the specified link with the provided token.
 *
 * @param {string} link - The endpoint to which the DELETE request is sent.
 * @param {string} [tok=""] - The authorization token to be included in the request headers.
 * @returns {Promise<Object>} - A promise that resolves to the JSON response from the server.
 */
export async function Remove(link, tok=""){ 
    const options = {
        method: 'delete',
        headers: {
            //'Content-Type': 'application/json',
            authorization:"Bearer "+tok,
        },
        Authorization:"Bearer "+tok,
    };
    const response = await customFetch(API+link, options);
    return checkStatus(response, tok).json();
}






